import type { AnnotationLabelT } from '../../../common/types/types';
import type { RemainingItem } from '../../../modernization-common/side-panel-m4/remaining-items/v2/types';
import { ITEM_CATEGORY, OBJECT_TYPE, REMAINING_ITEMS_GROUPING_KEY, TAG_LABEL } from '../../../modernization-common/side-panel-m4/remaining-items/v2/types';
export const computeLabelConstraintViolations = (annotationLabels: AnnotationLabelT[], annotationCountByLabel: Map<string, number>): RemainingItem[] => {
  const items: RemainingItem[] = [];
  for (const label of annotationLabels) {
    const count = annotationCountByLabel.get(label.title) ?? 0;
    const maxInstances = label.max ?? label.maxBoundingBoxes;
    if (label.isRequired && count === 0) {
      items.push({
        id: `missing-required-${label.title}`,
        label: label.title,
        objectType: OBJECT_TYPE.TASK,
        category: ITEM_CATEGORY.ERROR,
        description: `At least 1 instance of "${label.title}" is required, but none are present.`,
        tagLabel: TAG_LABEL.MISSING_REQUIRED,
        groupingKey: REMAINING_ITEMS_GROUPING_KEY.MISSING_REQUIRED
      });
    }
    if (maxInstances && count > maxInstances) {
      items.push({
        id: `max-exceeded-${label.title}`,
        label: label.title,
        objectType: OBJECT_TYPE.TASK,
        category: ITEM_CATEGORY.ERROR,
        description: `At most ${maxInstances} instance(s) of "${label.title}" are allowed, but ${count} instance(s) are present.`,
        tagLabel: TAG_LABEL.MAX_INSTANCES,
        groupingKey: REMAINING_ITEMS_GROUPING_KEY.INSTANCE_COUNT
      });
    }
  }
  return items;
};